<template>
  <loginless-layout :title="$t('profile.password.title')">
    <template v-if="!changed">
      <v-alert error :value="invalid">{{ $t('reset.invalidToken') }}</v-alert>
      <loadable v-if="!invalid" :loading="isBusy" only-hide>
        <password-form @save="save" :error="error" :complexity="passwordComplexity" />
      </loadable>
    </template>
    <template v-else>
      <v-alert success value="true">{{ $t('reset.success') }}</v-alert>
      <v-card-actions>
        <v-btn to='/'>{{ $t('reset.continue') }}</v-btn>
      </v-card-actions>
    </template>
  </loginless-layout>
</template>

<script>
import LoginlessLayout from '@/components/LoginlessLayout'
import PasswordForm from '@/components/PasswordForm'
import User from '@/models/User'

export default {
  props: ['token'],
  data () {
    return {
      isBusy: false,
      changed: false,
      error: null,
      invalid: null,
      passwordComplexity: null
    }
  },
  created () {
    this.isBusy = true

    User.getPasswordComplexity(this.token)
      .then(data => {
        this.passwordComplexity = data.passwordComplexity
        this.isBusy = false
      })
      .catch(error => {
        console.error(error)
        this.invalid = true
      })
  },
  methods: {
    save (password) {
      this.isBusy = true

      User
        .resetPassword(this.token, password)
        .then(() => {
          this.isBusy = false
          this.changed = true
        })
        .catch(err => {
          console.error(err)
          this.isBusy = false
          this.error = this.$t('savingFailed') + '.<br />' + err
        })
    }
  },
  components: {
    LoginlessLayout,
    PasswordForm
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PasswordReset.vue?1a74348e